import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Team, TeamCreate, TeamUpdate } from '../types/api.types'

export const teamsService = {
  async getAll(propertyId?: number): Promise<Team[]> {
    const params = new URLSearchParams()
    if (propertyId) params.append('property_id', propertyId.toString())
    const query = params.toString()
    const url = query ? `${API_ENDPOINTS.TEAMS}?${query}` : API_ENDPOINTS.TEAMS
    const { data } = await axiosInstance.get<Team[]>(url)
    return data
  },

  async getById(id: number): Promise<Team | null> {
    try {
      const { data } = await axiosInstance.get<Team>(API_ENDPOINTS.TEAM_BY_ID(id))
      return data
    } catch {
      return null
    }
  },

  async create(team: TeamCreate): Promise<Team> {
    const { data } = await axiosInstance.post<Team>(API_ENDPOINTS.TEAMS, team)
    return data
  },

  async update(id: number, team: TeamUpdate): Promise<Team> {
    const { data } = await axiosInstance.put<Team>(API_ENDPOINTS.TEAM_BY_ID(id), team)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.TEAM_BY_ID(id))
  },
}
